import './link.scss';

function Link(props) {
  return (
    <a href={props.href} target='_blank' rel="noreferrer"><img className='link' src={props.src} alt={props.alt}></img></a>
  );
}

export default Link;